import { combineReducers } from 'redux';
import { DDB_CONNECTION_GET_CONNECTIONS, DDB_CONNECTION_SHOW_CONNECTION_MODAL, DDB_CONNECTION_HIDE_CONNECTION_MODAL, DDB_CONNECTION_REMOVE_CONNECTION, DDB_CONNECTION_REMOVE_CONNECTIONS, DDB_CONNECTION_SHOW_DETAIL, DDB_CONNECTION_HIDE_DETAIL, DDB_CONNECTION_SAVE_CONNECTION, DDB_CONNECTION_GET_DATASET, DDB_CONNECTION_TEST_CONNECTION, DDB_CONNECTION_GET_CONNECTION_DETAIL, DDB_CONNECTION_GET_DATASETS_FOR_ALL_CONNECTIONS, DDB_CONNECTION_IS_CONNECTION_STRING_REMOVED } from './action.js';
import connectionControlReducer from './connection-control/reducer.js';
import { REQUEST_ERROR, REQUEST_START, REQUEST_SUCCESS } from '../../../middlewares/api/actions.js';
import { DDB_CONNECTION_CHANGE_CONNECTION_FORM } from './connection-control/actions.js';
import _ from 'lodash';

const ddbConnectionReducer = combineReducers({
    components: combineReducers({
        connectionControl: connectionControlReducer
    }),
    shared: (state = {
                connections: null,
                showModalConnection: false,
                connectionDetail: null,
                dataset: null,
                hasStartedSaving: false,
                savedSuccessfully: false,
                connectionName: null,
                dbType: null,
                connection: null,
                server: null,
                database: null,
                nodeId: null,
                port: null,
                userId: null,
                password: null,
                dataSource: null,
                integratedSecurity: false,
                connectionType: null,
                oracleConfigurationFile: null,
                dbName: null,
                entityId: null,
                realDbType: null,
                sid: null,
                creating: false,
                connectionTestPassed: false,
                datasetsForAllConnections: null,
                areDatasetsInConnections: false,
                isConnectionRemoved: false
        },
    action) => {
    switch (action.type) {
        case DDB_CONNECTION_GET_CONNECTION_DETAIL:{
            let selectedConnection = '';
            let selectedConnections = []
            if(!Array.isArray(action.entityId)) {
                selectedConnection = _.find(state.connections, (connection) => connection.entityId === action.entityId);
            } else {
                _.forEach(state.connections, (connection) => _.filter(action.entityId, (actionElement) => {if(connection.entityId === actionElement){selectedConnections.push(connection)}}));
            }
            return {
                ...state,
                connectionDetail: selectedConnections.length > 0 ? selectedConnections : selectedConnection,
            }
        }
        case DDB_CONNECTION_SHOW_CONNECTION_MODAL: {
            return {
                ...state,
                showModalConnection: true
            }
        }
        case DDB_CONNECTION_HIDE_CONNECTION_MODAL: {
            return {
                ...state,
                showModalConnection: false
            }
        }
        // Mostra la connectionDetail nel modal di edit connection
        case DDB_CONNECTION_SHOW_DETAIL:{
            return {
                ...state,
                connectionDetail: action.data,
                showModalConnection: true,
                creating: action.creating
            }
        }
        case DDB_CONNECTION_HIDE_DETAIL:{
            return {
                ...state,
                connectionDetail: null,
                showModalConnection: false
            }
        }
        case DDB_CONNECTION_CHANGE_CONNECTION_FORM:
            let {   
                    connectionName,
                    dbType,
                    connection,
                    server,
                    database,
                    nodeId,
                    port,
                    userId,
                    password,
                    dataSource,
                    integratedSecurity,
                    connectionType,
                    oracleConfigurationFile,
                    dbName,
                    entityId,
                    realDbType,
                    sid
                } = _.mapValues(action.fields, field => field.value)

            if(!!dbType && !!state.connectionDetail && (dbType !== state.connectionDetail.dbType)) {
                return {
                    ...state,
                    connectionDetail: {
                        connectionName: checkFieldValue('connectionName',connectionName, state.connectionDetail),
                        dbType: checkFieldValue('dbType',dbType, state.connectionDetail),        
                    }
                }
            }
            if(!!connectionType && !!state.connectionDetail && (connectionType !== state.connectionDetail.connectionType)) {
                return {
                    ...state,
                    connectionDetail: {
                        connectionName: checkFieldValue('connectionName',connectionName, state.connectionDetail),
                        dbType: checkFieldValue('dbType',dbType, state.connectionDetail),
                        connectionType: checkFieldValue('connectionType',connectionType, state.connectionDetail),        
                    }
                }
            }
            return {
                ...state,
                connectionDetail: {
                    connectionName: checkFieldValue('connectionName',connectionName, state.connectionDetail),
                    dbType: checkFieldValue('dbType',dbType, state.connectionDetail),
                    connection: !!state.isConnectionRemoved ? null : checkFieldValue('connection',connection, state.connectionDetail),
                    server: checkFieldValue('server',server, state.connectionDetail),
                    database: checkFieldValue('database',database, state.connectionDetail),
                    port: checkFieldValue('port',port, state.connectionDetail),
                    userId: integratedSecurityCheck('userId',userId, state.connectionDetail),
                    password: integratedSecurityCheck('password',password, state.connectionDetail),
                    dataSource: checkFieldValue('dataSource',dataSource, state.connectionDetail),
                    integratedSecurity: checkFieldValue('integratedSecurity',integratedSecurity, state.connectionDetail),
                    connectionType: checkFieldValue('connectionType',connectionType, state.connectionDetail),
                    oracleConfigurationFile: checkFieldValue('oracleConfigurationFile',oracleConfigurationFile, state.connectionDetail),
                    dbName: checkFieldValue('dbName',dbName, state.connectionDetail),
                    entityId: checkFieldValue('entityId',entityId, state.connectionDetail),
                    realDbType: !!state.isConnectionRemoved ? null : checkFieldValue('realDbType',realDbType, state.connectionDetail),
                    sid: checkFieldValue('sid',sid, state.connectionDetail),
                    nodeId: !!state.isConnectionRemoved ? null : checkFieldValue('nodeId',nodeId, state.connectionDetail),
                },
                isConnectionRemoved: false
            }
        /*Evento scatenato al click sul bottone di reset del selector 
        * per la scelta di una connessione, quando il dbType è MDM 
        */
        case DDB_CONNECTION_IS_CONNECTION_STRING_REMOVED: {
            return {
                ...state,
                isConnectionRemoved: true
            }
        }
        case REQUEST_START:
            switch(action.label){
                case DDB_CONNECTION_GET_CONNECTIONS: {
                    return {
                        ...state,
                        connections: [],
                        savedSuccessfully: false,
                        hasStartedSaving: false
                    }
                }
                case DDB_CONNECTION_SAVE_CONNECTION:{
                    return {
                        ...state,
                        hasStartedSaving: true,
                        savedSuccessfully: false,
                    }
                }
                case DDB_CONNECTION_TEST_CONNECTION:{
                    return {
                        ...state,
                        connectionTestPassed: false,
                    }
                }
                case DDB_CONNECTION_GET_DATASET:{
                    return {
                        ...state,
                        dataset: null
                    }
                }
                case DDB_CONNECTION_GET_DATASETS_FOR_ALL_CONNECTIONS:{
                    return {
                        ...state,
                        areDatasetsInConnections: false,
                        datasetsForAllConnections: null
                    }
                }
                default:
                    return {
                        ...state
                    }
            }
        case REQUEST_SUCCESS:
            switch(action.label){
                case DDB_CONNECTION_GET_CONNECTIONS: {
                    return {
                        ...state,
                        connections: action.response,
                        savedSuccessfully: false,
                        hasStartedSaving: false
                    }
                }
                case DDB_CONNECTION_SAVE_CONNECTION:{
                    return {
                        ...state,
                        hasStartedSaving: true,
                        savedSuccessfully: true,
                        showModalConnection: false,
                        connectionDetail: null
                    }
                }
                case DDB_CONNECTION_REMOVE_CONNECTION:{
                    const connectionsClone = _.cloneDeep(state.connections);
                    const deletedConnectionIndex = _.findIndex(connectionsClone, (conn) => conn.entityId === action.connectionDeleted.entityId);
                    if (deletedConnectionIndex === -1) {
                        return state;
                    } else {
                        connectionsClone.splice(deletedConnectionIndex, 1);
                        return {
                            ...state,
                            connections: connectionsClone,
                            connectionDetail: null
                        }
                    }
                }
                case DDB_CONNECTION_REMOVE_CONNECTIONS:{
                    const connectionsClone = _.cloneDeep(state.connections);
                    action.connectionsDeleted.forEach((el) => {
                        const deletedConnectionIndex = connectionsClone.findIndex((conn) => conn.entityId === el.entityId);
                        if (deletedConnectionIndex !== -1) {
                            connectionsClone.splice(deletedConnectionIndex, 1);
                        } else {
                            return state
                        }
                    })
                    return {
                        ...state,
                        connections: connectionsClone,
                        connectionDetail: null
                    }
                }
                case DDB_CONNECTION_TEST_CONNECTION:{
                    return {
                        ...state,
                        connectionTestPassed: action.response,
                    }
                }
                case DDB_CONNECTION_GET_DATASET:{
                    return {
                        ...state,
                        dataset: action.response
                    }
                }
                case DDB_CONNECTION_GET_DATASETS_FOR_ALL_CONNECTIONS:{
                    return {
                        ...state,
                        areDatasetsInConnections: action.response.areDatasetsInConnections,
                        datasetsForAllConnections: action.response.datasetsForAllConnections
                    }
                }
                default:
                    return {
                        ...state
                    }
            }
        case REQUEST_ERROR:
            switch(action.label){
                case DDB_CONNECTION_GET_CONNECTIONS: {
                    return {
                        ...state,
                        error: action.response,
                        hasStartedSaving: false,
                        savedSuccessfully: false,
                    }
                }
                case DDB_CONNECTION_SAVE_CONNECTION:{
                    return {
                        ...state,
                        savedSuccessfully: false,
                        hasStartedSaving: false,
                    }
                }
                case DDB_CONNECTION_TEST_CONNECTION:{
                    return {
                        ...state,
                        connectionTestPassed: false,
                    }
                }
                case DDB_CONNECTION_GET_DATASET:{
                    return {
                        ...state,
                        dataset: null
                    }
                }
                case DDB_CONNECTION_GET_DATASETS_FOR_ALL_CONNECTIONS:{
                    return {
                        ...state,
                        areDatasetsInConnections: false,
                        datasetsForAllConnections: null
                    }
                }
                default:
                    return {
                        ...state
                    }
            }
        default:
            return {
                ...state
            };
    }
    }
})

function checkFieldValue(name,field,connectionDetail) {
    return (field !== null && field !== undefined) ? field : (!!connectionDetail ? connectionDetail[name] : null);
}
function integratedSecurityCheck(name,field, connectionDetail) {
    return ((!!connectionDetail  && !!connectionDetail['integratedSecurity']) ? null : (field !== null && field !== undefined) ? field : (!!connectionDetail ? connectionDetail[name] : null));
}

export default ddbConnectionReducer;